<div class="sidebar-wrapper">
  <button class="sidebar-toggle" (click)="sidebarOpen = !sidebarOpen">
    <img src="assets/images/svg/list-icon.svg" alt="" />
  </button>
  @if (sidebarOpen) {
    <div class="sidebar-overlay" (click)="sidebarOpen = false"></div>
  }
  <div class="sidenav" [class.open]="sidebarOpen">
    <ul class="nav flex-column">
      @for (menu of sidebarMenu; track menu) {
        @if (!menu.isSubMenu) {
          <li class="nav-item "
            [ngClass]="{'active' : sidebarstatus === menu.sidebarstatus}">
            <a class="nav-link" [routerLink]="menu.url" (click)="clickItem(menu.sidebarstatus,menu.pageTile, menu.url, true); sidebarOpen = false">
              <div class="nav-icon">
                <img [src]="menu?.imgIcon" alt="">
              </div>
              <span>
                {{menu.sideItem}}
              </span>
            </a>
          </li>
        } @else {
          <li class="sub-menu" >
            <a class="nav-link sub-link" (click)="toggleSubMenu(menu.sidebarstatus)">
              <div class="nav-icon">
                <img [src]="menu.imgIcon" alt="">
              </div>
              <span>
                {{menu.sideItem}}
                @if (menu.beta) {
                  <small class="beta-label">تجريبي</small>
                }
              </span>
            </a>
            @if (dropdowns[menu.sidebarstatus]) {
              <ul>
                @for (subMenu of menu.subMenuItems; track subMenu) {
                  <li class="nav-item  sub-items"
                    [ngClass]="{'active' : sidebarstatus === subMenu.sidebarstatus}">
                    <a class="nav-link" [routerLink]="subMenu.url" #elements (click)="clickItem(subMenu.sidebarstatus, subMenu.pageTile, subMenu.url, false); sidebarOpen = false">
                      <span> {{subMenu.item}} </span>
                    </a>
                  </li>
                }
              </ul>
            }
          </li>
        }
      }
    </ul>
  </div>
</div>
